<template>
  <div class="regular-header werkwijze">
      <navbar />

    <headerGrid>
      <div class="font-size-custom-max-48"><h1 id="font-calc-3">Eigen(werk)wijze</h1></div>
      <p>Zonder klik geen resultaat. In onze werkwijze staat samenwerken centraal. Plezier en elkaar leren kennen is voor ons net zo belangrijk als de deadline die we samen afstemmen. We smelten samen tot één team, dat is hoe we het doen. Benieuwd hoe dat precies werkt? Lees dan hieronder verder.</p>
      <a v-scroll-to="'#icons'"><img src="../assets/Folded_Paper_asset_arrow_down.png"></a>
   </headerGrid>

  <div class="container">
    <div class="icon-grid">
      <iconGrid id="icons" v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
          <img src="../assets/Folded_Paper_Icon_digital_first_branding.svg">
          <h2 class="font-size-custom-max-28">Digital first branding</h2>
          <p>De wereld is digitaal. Jouw merk is daar een onderdeel van. Dus heb je een identiteit nodig met een digitale hartslag. Wij starten altijd met een merkidentiteit sessie, en kijken vanuit daar naar eventuele andere behoeftes.</p>
          <!-- <scissorsButton>
            <router-link to="/werkwijze" class="button"><p>Je hebt me overtuigd!</p></router-link>
          </scissorsButton> -->
      </iconGrid>

      <iconGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
          <img src="../assets/Folded_Paper_icon_product_design.svg">
          <h2 class="font-size-custom-max-28">Product <br> design</h2>
          <p>We ontwerpen nieuwe digitale producten. Handige tools en services die je elke dag gebruikt. En die een glimlach op je gezicht toveren. Benieuwd welke producten? klik dan  <router-link to="/werk">hier</router-link> voor een selectie van ons werk.</p>
           <scissorsButton>
            <!-- <router-link to="/contact" class="button"><p>Je hebt me overtuigd!</p></router-link> -->
          </scissorsButton>
      </iconGrid>

      <iconGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
          <img src="../assets/Folded_Paper_icon_transformeren.svg">
          <h2 class="font-size-custom-max-28">Digitaal transformeren</h2>
          <p>Willen jullie stappen zetten om digitaal te transformeren maar weet je niet hoe je moet beginnen? Wij helpen graag bij deze zoektocht.</p>
         <!-- <scissorsButton>
            <router-link to="/werkwijze" class="button"><p>Je hebt me overtuigd!</p></router-link>
          </scissorsButton> -->
      </iconGrid>
    </div>
  </div>
  

  <howWeWork></howWeWork>

   <oddEvenGrid  v-scroll-reveal="{ delay: 550, viewFactor: 0.2}"> 
    <div class="odd-even-grid odd">
      <div class="img-box">
        <img src="../assets/Folded_Paper_agile_design.svg">
      </div>
      <div class="text-box">
        <div class="content">
          <h3>Agile design</h3>
          <p>In kleine teams zullen wij meerdere disciplines bij elkaar laten komen. Bij alles wat we doen staat onderbuikgevoel bevestigen centraal. Designen testen designen en weer testen.</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.2}"> 
    <div class="odd-even-grid last-item even">
      <div class="text-box">
        <div class="content">
          <h3>Samen staan we sterker</h3>
          <p>Wij werken niet voor je maar met je. Dit zorgt voor gezamenlijke verantwoordelijkheid en betrokkenheid. Deadlines zullen samen gesteld worden en de lijntjes zijn extreem kort. Er zullen geen tussenpersonen zijn, alleen zelfstandige designers.</p>
        </div>
      </div>
      <div class="img-box">
        <img src="../assets/Folded_Paper_samen_sterker.svg">
      </div>
    </div>
  </oddEvenGrid>
  <footerComponent></footerComponent>

  </div>
</template>

<script>
import headerGrid from '@/components/generalLayout/headerGrid.vue';
import iconGrid from '@/components/generalLayout/iconGrid.vue';
import howWeWork from '@/components/specificLayout/howWeWork.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';
import navbar from '@/components/generalLayout/navbar.vue';
import scissorsButton from '@/components/generalLayout/scissorsButton.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

export default {
  name: 'werkwijze',

  components:{
    headerGrid,
    iconGrid,
    howWeWork,
    oddEvenGrid,
    navbar,
    scissorsButton,
    footerComponent
  },
methods: {
  noPageTransition() {
  },
  pageTransition() {
    window.location = './netflix';
  },
  },
}

</script>

<style lang="scss" scoped>

.button {
  p{
    margin: 0;
  }
}
.werkwijze{
  .this-is-how-we-work{
    padding-bottom: 0px;
  }
  .icon-grid{
    @include opacityShow;
    animation-delay: 1.2s;
    opacity: 0;
  }
  a{
    @include fluid-type(14px, 18px);
  }
}
 .img-box{
  img{
    max-width: 360px !important;
    max-height:500px !important;
    margin: 0 auto;
    display: block;
    border-radius: 0; 
  }
}

  .button{
    text-decoration: none;
    p{
      font-weight: 800;
      list-style: none;
    }
  }


@media screen and (max-width: 640px) {
  .icon-box{
    width: 100%;
  } 
}
</style>
